import { render, staticRenderFns } from "./textscroll.vue?vue&type=template&id=461f30fe"
import script from "./textscroll.vue?vue&type=script&lang=js"
export * from "./textscroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports